import { Abstract } from './abstract';
import { Issue } from './issue';
import { CivilCase } from './../civil-case';
import { SafeJSON } from './../../shared/safe-json';

export class Transcript {
    public json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
     }
    getKey(): string {
        return this.key;
    }
    getDestinationCounty(): string {
        return SafeJSON.get('transcriptedCaseNumber.county', this.json);
    }

    getAbstractNumber(): string {
        // handle PreJA where the abstract number is a letter; ie 'A'
        // Currituck 2003CR106
        let preJAAbstractRef: string = SafeJSON.getWithDefault('preJAAbstractRef', this.json);
        if (preJAAbstractRef !== '-') {
            return SafeJSON.get('abstractNumber', this.json);
        }

        // this abstract number is numeric
        let abstractNumber = SafeJSON.getNumber('abstractNumber', this.json);
        if (abstractNumber !== null) {
           return abstractNumber.toString();
        }
        return '';
    }
    getStatus(): string {
        const status = SafeJSON.get('status', this.json);
        if (status === 'C') {
            return 'CANCELLED';
        }
        return 'ACTIVE';
    }
    getExemption(): string {
        const field = SafeJSON.get('exemptIndicator', this.json);
        if (field === 'Y') {
            return 'EXEMPTION ORDER FOR EXECUTION';
        }
        return 'NONE';
    }
    getDateTime(): string {
        return SafeJSON.get('transcriptOn', this.json);
    }
    getDateTimeOmitSeconds(): string {
         // We get this:  2004-05-17T14:58:56.414232
         // We want this: 2004-05-17T14:58:56.000000
         //               01234567890123456789012345
        let dateTime: string = SafeJSON.get('transcriptOn', this.json);
        const periodIndex = dateTime.indexOf('.') - 2;
        dateTime = dateTime.slice(0, periodIndex);
        dateTime = dateTime + '10.000000';
        return dateTime;
    }
    getDocketBookNum(): string {
        return SafeJSON.get('docketBookNum', this.json);
    }
    getDocketPageNum(): string {
        return SafeJSON.get('docketPageNum', this.json);
    }
    getAbstractOrDocketInfo(civilCase: CivilCase): string {
        const docketBookNum = this.getDocketBookNum();
        const docketPageNum = this.getDocketPageNum();

        const SPECIALBOOKPAGE8S = '888';
        const SPECIALBOOKPAGE9S = '999';

        if (docketBookNum !== '' && docketBookNum !== SPECIALBOOKPAGE8S && docketBookNum !== SPECIALBOOKPAGE9S) {
            const text = 'Order Book ' + docketBookNum + ' Page ' + docketPageNum;
            return text;
        }
        // transcript was for an abstract
        let abstractCode = SafeJSON.getWithDefault('abstractCode', this.json);
        let abstractLabel = this.getTranslateAbstractCodeToLabel(abstractCode);
        let abstractNumber = this.getAbstractNumber();   // 1 or A

        let preJAAbstractRef: string = SafeJSON.getWithDefault('preJAAbstractRef', this.json);
        if (preJAAbstractRef !== '-') {
            // for PreJA, there is no abstract code
            return abstractLabel + ' ' + abstractNumber;
        }
        // this is not preJA
        if (abstractCode !== '-') {
            return abstractLabel + ' ' + abstractNumber;
        }

        // need to look up the issue and get the abstract type and number
        let issueKey = SafeJSON.get('issueKey', this.json);
        let issue: Issue = civilCase.getIssueListByKey(issueKey);
        let abstractRef = issue.getAbstractRefKey();
        let abstract: Abstract = civilCase.getAbstractByKey(abstractRef);
        if (abstract === undefined) {
            return 'See clerk for details.';
        }
        abstractCode = abstract.getAbstractCode();
        abstractNumber = abstract.getAbstractJudgmentNumber().toString();
        abstractLabel = this.getTranslateAbstractCodeToLabel(abstractCode);
        return abstractLabel + ' ' + abstractNumber;
    }
    getTranslateAbstractCodeToLabel(code: string): string {
        if (code === 'Q') {
            return 'SPECIAL ABSTRACT';
        }
        return 'JUDGMENT';
    }
}




// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/transcript.ts